export function downloadFile(data, filename = '默认名称') {
  let date = new Date()
  let dates = date.toLocaleString()
  const blob = new Blob([data]) //处理文档流
  const fileName = filename + dates + '.xlsx'
  const elink = document.createElement('a')
  elink.download = fileName
  elink.style.display = 'none'
  elink.href = URL.createObjectURL(blob)
  document.body.appendChild(elink)
  elink.click()
  URL.revokeObjectURL(elink.href) // 释放URL 对象
  document.body.removeChild(elink)
}

export function downloadZip(data, filename = '默认名称') {
  let blob = new Blob([data], { type: 'application/zip' })
  let url = window.URL.createObjectURL(blob)
  const link = document.createElement('a') // 创建a标签
  link.style.display = 'none'
  link.download = filename
  link.href = url
  link.click()
  URL.revokeObjectURL(url) // 释放内存
}
